module.exports = __webpack_public_path__ + "img/IMG_6984_L_BlackMatted_MockedUp.38c1c2e5.jpg";